import { useQuery } from '@tanstack/react-query';
export const fetchMultiTokens = async (tokens, minMarketCap) => {
  const networks = [1, 137, 10, 56, 43114, 42161, 250, 8453, 81457, 1399811149];
  const url = '/api/explore/multiTokenData';
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      networks,
      tokens
    })
  });
  const payload = await response.json();
  const data = payload === null || payload === void 0 ? void 0 : payload.data;
  let results = data.data.filterTokens.results;
  results = results.filter(x => {
    return parseFloat(x.marketCap) >= minMarketCap;
  }).sort((a, b) => {
    var _a, _b, _c, _d;
    if (((_a = a === null || a === void 0 ? void 0 : a.token) === null || _a === void 0 ? void 0 : _a.networkId) === 1 && ((_b = b === null || b === void 0 ? void 0 : b.token) === null || _b === void 0 ? void 0 : _b.networkId) !== 1) {
      return 1;
    }
    if (((_c = a === null || a === void 0 ? void 0 : a.token) === null || _c === void 0 ? void 0 : _c.networkId) !== 1 && ((_d = b === null || b === void 0 ? void 0 : b.token) === null || _d === void 0 ? void 0 : _d.networkId) === 1) {
      return -1;
    }
    const marketCapDiff = b.marketCap - a.marketCap;
    if (marketCapDiff > 0) {
      return 2;
    } else if (marketCapDiff < 0) {
      return -2;
    }
    return 0;
  });
  return results;
};
export default function useMultiTokenData({
  tokens,
  minMarketCap = 1000000,
  staleTime = 1000 * 60 * 30,
  enabled = true
}) {
  const query = useQuery({
    queryKey: ['multiTokenData', tokens, minMarketCap],
    queryFn: async () => {
      var _a;
      const tokenArray = tokens.reduce((acc, curr, i) => {
        if (i % 80 === 0) {
          acc.push([]);
        }
        acc[acc.length - 1].push(curr);
        return acc;
      }, []);
      const data = (_a = await Promise.all((tokenArray || [tokens]).map(tokenArray => fetchMultiTokens(tokenArray, minMarketCap)))) === null || _a === void 0 ? void 0 : _a.flat();
      return data;
    },
    staleTime,
    enabled
  });
  return query;
}